import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<span class=\"badge\">New</span>\n",{ moduleName: "client-portal/components/site/documents/new-badge.hbs" })